export const mockDataBar1 = [
    {
      "key": "Jan",
      "PAX": 148,
      "Cefalù": 89,
      "Berlin": 33,
      "Istanbul": 118,
      "Michel": 132,
      "Louise": 153,
    },
    {
      "key": "Fév",
      "PAX": 152,
      "Cefalù": 48,
      "Berlin": 23,
      "Istanbul": 62,
      "Michel": 128,
      "Louise": 0,
    },
    {
      "key": "Mar",
      "PAX": 161,
      "Cefalù": 83,
      "Berlin": 182,
      "Istanbul": 198,
      "Michel": 55,
      "Louise": 167,
    },
    {
      "key": "Avr",
      "PAX": 148,
      "Cefalù": 182,
      "Berlin": 181,
      "Istanbul": 101,
      "Michel": 69,
      "Louise": 95,
    },
    {
      "key": "Mai",
      "PAX": 135,
      "Cefalù": 93,
      "Berlin": 100,
      "Istanbul": 69,
      "Michel": 113,
      "Louise": 110,
    },
    {
      "key": "Juin",
      "PAX": 65,
      "Cefalù": 53,
      "Berlin": 112,
      "Istanbul": 172,
      "Michel": 94,
      "Louise": 189,
    },
    {
      "key": "Juil",
      "PAX": 49,
      "Cefalù": 80,
      "Berlin": 55,
      "Istanbul": 105,
      "Michel": 103,
      "Louise": 191,
    }
  ]
  
  
  export const mockDataBar2 = [
    {
      "key": "Jan",
      "N": 148,
      "N1": 125,
      "objectif": 148,
      "PAXColor": "hsl(243, 70%, 50%)"
    },
    {
      "key": "Fév",
      "N": 152,
      "N1": 163,
      "objectif": 163,
      "PAXColor": "hsl(272, 70%, 50%)"
    },
    {
      "key": "Mar",
      "N": 161,
      "N1": 152,
      "objectif": 152,
      "PAXColor": "hsl(89, 70%, 50%)"
    },
    {
      "key": "Avr",
      "N": 148,
      "N1": 163,
      "objectif": 163,
      "PAXColor": "hsl(62, 70%, 50%)"
    },
    {
      "key": "Mai",
      "N": 135,
      "N1": 100,
      "objectif": 135,
      "PAXColor": "hsl(16, 70%, 50%)"
    },
    {
      "key": "Juin",
      "N": 65,
      "N1": 40,
      "objectif": 70,
      "PAXColor": "hsl(19, 70%, 50%)"
    },
    {
      "key": "Juil",
      "N": 49,
      "N1": 80,
      "objectif": 80,
      "PAXColor": "hsl(73, 70%, 50%)"
    }
  ]

export const mockDataBar22 = [
  {
    "key": "Type 1",
    "N": 148,
    "N1": 125,
    "objectif": 148,
    "PAXColor": "hsl(243, 70%, 50%)"
  },
  {
    "key": "Type 2",
    "N": 152,
    "N1": 163,
    "objectif": 163,
    "PAXColor": "hsl(272, 70%, 50%)"
  },
  {
    "key": "Type 3",
    "N": 161,
    "N1": 152,
    "objectif": 152,
    "PAXColor": "hsl(89, 70%, 50%)"
  },
  {
    "key": "Type 4",
    "N": 148,
    "N1": 163,
    "objectif": 163,
    "PAXColor": "hsl(62, 70%, 50%)"
  },
  {
    "key": "Type 5",
    "N": 135,
    "N1": 100,
    "objectif": 135,
    "PAXColor": "hsl(16, 70%, 50%)"
  }
]

export const mockDataBar3 = [
  {
    "key": "Type 1",
    "Type 1": 148,
    "PAXColor": "hsl(243, 70%, 50%)"
  },
  {
    "key": "Type 2",
    "Type 2": 70,
    "PAXColor": "hsl(272, 70%, 50%)"
  },
  {
    "key": "Type 3",
    "Type 3": 161,
    "PAXColor": "hsl(89, 70%, 50%)"
  },
  {
    "key": "Type 4",
    "Type 4": 120,
    "PAXColor": "hsl(89, 70%, 50%)"
  },
  {
    "key": "Type 5",
    "Type 5": 140,
    "PAXColor": "hsl(89, 70%, 50%)"
  }
]


export const mockDataBarRes = [
  {
    "key": "Jan",
    "Réseau 1": 148,
    "Réseau 2": 89,
    "Réseau 3": 33,
    "Réseau 4": 118
  },
  {
    "key": "Fev",
    "Réseau 1": 23,
    "Réseau 2": 94,
    "Réseau 3": 76,
    "Réseau 4": 45
  },
  {
    "key": "Mar",
    "Réseau 1": 185,
    "Réseau 2": 53,
    "Réseau 3": 68,
    "Réseau 4": 79
  },
  {
    "key": "Avr",
    "Réseau 1": 148,
    "Réseau 2": 89,
    "Réseau 3": 33,
    "Réseau 4": 118
  },
  {
    "key": "Mai",
    "Réseau 1": 148,
    "Réseau 2": 89,
    "Réseau 3": 33,
    "Réseau 4": 118
  },
  {
    "key": "Jui",
    "Réseau 1": 148,
    "Réseau 2": 89,
    "Réseau 3": 33,
    "Réseau 4": 118
  },
]




export const mockDataBarDest = [
  {
    "key": "Mai",
    "Paris": 63,
    "Madrid": 89,
    "Rome": 33,
    "Berlin": 118
  },
  {
    "key": "Jan",
    "Paris": 148,
    "Madrid": 89,
    "Rome": 33,
    "Berlin": 118
  },
  {
    "key": "Mar",
    "Paris": 18,
    "Madrid": 53,
    "Rome": 68,
    "Berlin": 79
  },
  {
    "key": "Avr",
    "Paris": 108,
    "Madrid": 89,
    "Rome": 33,
    "Berlin": 118
  },
  {
    "key": "Fev",
    "Paris": 23,
    "Madrid": 94,
    "Rome": 76,
    "Berlin": 45
  },
  {
    "key": "Jui",
    "Paris": 148,
    "Madrid": 89,
    "Rome": 33,
    "Berlin": 118
  },
]



export const mockDataDest2 = [
  {
    "key": "Madrid",
    "Achats": 75,
    "PAXColor": "hsl(243, 70%, 50%)"
  },
  {
    "key": "Paris",
    "Achats": 120,
    "PAXColor": "hsl(272, 70%, 50%)"
  },
  {
    "key": "Berlin",
    "Achats": 50,
    "PAXColor": "hsl(89, 70%, 50%)"
  },
  {
    "key": "Rome",
    "Achats": 108,
    "PAXColor": "hsl(62, 70%, 50%)"
  },  {
    "key": "Istanbul",
    "Achats": 18,
    "PAXColor": "hsl(62, 70%, 50%)"
  },  {
    "key": "Milan",
    "Achats": 38,
    "PAXColor": "hsl(62, 70%, 50%)"
  }
]

export const mockDataBarMois = [
  {
    "key": "jan",
    "N": 15,       // Valeur de l'année en cours en %
    "N-1": 10,     // Valeur de l'année précédente en %
    "budget": 18   // Objectif budgétaire en %
  },
  {
    "key": "fev",
    "N": 12,
    "N-1": 8,
    "budget": 15
  },
  {
    "key": "mars",
    "N": 17,
    "N-1": 13,
    "budget": 19
  },
  {
    "key": "avril",
    "N": 20,
    "N-1": 14,
    "budget": 18
  },
  {
    "key": "mai",
    "N": 10,
    "N-1": 7,
    "budget": 12
  },
  {
    "key": "juin",
    "N": 8,
    "N-1": 6,
    "budget": 10
  },
  {
    "key": "juil",
    "N": 14,
    "N-1": 9,
    "budget": 16
  },
  {
    "key": "aou",
    "N": 13,
    "N-1": 10,
    "budget": 15
  }
];

export const mockDataBarDestinations = [
  {
    "key": "Paris",
    "N": 12,       // Valeur de l'année en cours en %
    "N-1": 9,      // Valeur de l'année précédente en %
    "budget": 15   // Objectif budgétaire en %
  },
  {
    "key": "Londres",
    "N": 16,
    "N-1": 11,
    "budget": 18
  },
  {
    "key": "New York",
    "N": 18,
    "N-1": 13,
    "budget": 20
  },
  {
    "key": "Tokyo",
    "N": 14,
    "N-1": 10,
    "budget": 17
  },
  {
    "key": "Berlin",
    "N": 9,
    "N-1": 7,
    "budget": 12
  },
  {
    "key": "Rome",
    "N": 11,
    "N-1": 8,
    "budget": 13
  },
  {
    "key": "Sydney",
    "N": 19,
    "N-1": 14,
    "budget": 20
  },
  {
    "key": "Dubai",
    "N": 13,
    "N-1": 9,
    "budget": 15
  }
];

export const mockDataBarRéseau = [
  {
    "key": "réseau1",
    "N": 14,       // Valeur de l'année en cours en %
    "N-1": 10,     // Valeur de l'année précédente en %
    "budget": 16   // Objectif budgétaire en %
  },
  {
    "key": "réseau2",
    "N": 17,
    "N-1": 12,
    "budget": 19
  },
  {
    "key": "réseau3",
    "N": 20,
    "N-1": 15,
    "budget": 18
  },
  {
    "key": "réseau4",
    "N": 10,
    "N-1": 8,
    "budget": 12
  },
  {
    "key": "réseau5",
    "N": 13,
    "N-1": 9,
    "budget": 14
  },
  {
    "key": "réseau6",
    "N": 15,
    "N-1": 11,
    "budget": 17
  },
  {
    "key": "réseau7",
    "N": 9,
    "N-1": 6,
    "budget": 10
  },
  {
    "key": "réseau8",
    "N": 18,
    "N-1": 14,
    "budget": 20
  }
];

export const mockDataBarPersonnes = [
  {
    "key": "Alice Dupont",
    "N": 16,       // Valeur de l'année en cours en %
    "N-1": 12,     // Valeur de l'année précédente en %
    "budget": 18   // Objectif budgétaire en %
  },
  {
    "key": "Bruno Martin",
    "N": 19,
    "N-1": 14,
    "budget": 20
  },
  {
    "key": "Caroline Leroy",
    "N": 15,
    "N-1": 10,
    "budget": 17
  },
  {
    "key": "David Moreau",
    "N": 11,
    "N-1": 8,
    "budget": 13
  },
  {
    "key": "Emma Fournier",
    "N": 13,
    "N-1": 9,
    "budget": 15
  },
  {
    "key": "Fabien Dubois",
    "N": 10,
    "N-1": 7,
    "budget": 12
  },
  {
    "key": "Gaëlle Lefevre",
    "N": 18,
    "N-1": 14,
    "budget": 20
  },
  {
    "key": "Hugo Bernard",
    "N": 12,
    "N-1": 9,
    "budget": 14
  }
];


export const mockDataBarDest2 = [
  {
    "key": "Paris",
    "N": 135,
    "N-1": 80,
    "objectif": 150,
  },
  {
    "key": "New York",
    "N": 90,
    "N-1": 75,
    "objectif": 100,
  },
  {
    "key": "Tokyo",
    "N": 120,
    "N-1": 100,
    "objectif": 130,
  },
  {
    "key": "London",
    "N": 155,
    "N-1": 130,
    "objectif": 160,
  },
  {
    "key": "Sydney",
    "N": 100,
    "N-1": 85,
    "objectif": 110,
  },
  {
    "key": "Berlin",
    "N": 75,
    "N-1": 60,
    "objectif": 90,
  },
  {
    "key": "Toronto",
    "N": 130,
    "N-1": 110,
    "objectif": 140,
  },
  {
    "key": "Moscow",
    "N": 110,
    "N-1": 95,
    "objectif": 120,
  },
  {
    "key": "Mumbai",
    "N": 160,
    "N-1": 140,
    "objectif": 170,
  },
  {
    "key": "Beijing",
    "N": 145,
    "N-1": 120,
    "objectif": 155,
  },
  {
    "key": "Dubai",
    "N": 80,
    "N-1": 65,
    "objectif": 90,
  },
  {
    "key": "Rome",
    "N": 115,
    "N-1": 95,
    "objectif": 125,
  },
  {
    "key": "Istanbul",
    "N": 95,
    "N-1": 80,
    "objectif": 105,
  },
  {
    "key": "Bangkok",
    "N": 125,
    "N-1": 110,
    "objectif": 135,
  },
  {
    "key": "Los Angeles",
    "N": 105,
    "N-1": 90,
    "objectif": 115,
  },
  {
    "key": "Madrid",
    "N": 135,
    "N-1": 115,
    "objectif": 145,
  },
  {
    "key": "Hong Kong",
    "N": 85,
    "N-1": 70,
    "objectif": 95,
  },
  {
    "key": "São Paulo",
    "N": 140,
    "N-1": 120,
    "objectif": 150,
  },
  {
    "key": "Mexico City",
    "N": 100,
    "N-1": 85,
    "objectif": 110,
  },
  {
    "key": "Seoul",
    "N": 150,
    "N-1": 130,
    "objectif": 160,
  }
];


export const mockDataBarDest3 = [
  {
    "key": "Paris",
    "N": 15,
    "N-1": 12,
  },
  {
    "key": "New York",
    "N": 13,
    "N-1": 11,
  },
  {
    "key": "Tokyo",
    "N": 14,
    "N-1": 13,
  },
  {
    "key": "London",
    "N": 16,
    "N-1": 14,
  },
  {
    "key": "Sydney",
    "N": 12,
    "N-1": 10,
  },
  {
    "key": "Berlin",
    "N": 11,
    "N-1": 9,
  },
  {
    "key": "Toronto",
    "N": 14,
    "N-1": 12,
  },
  {
    "key": "Moscow",
    "N": 13,
    "N-1": 11,
  },
  {
    "key": "Mumbai",
    "N": 17,
    "N-1": 15,
  },
  {
    "key": "Beijing",
    "N": 16,
    "N-1": 14,
  },
  {
    "key": "Dubai",
    "N": 10,
    "N-1": 8,
  },
  {
    "key": "Rome",
    "N": 12,
    "N-1": 10,
  },
  {
    "key": "Istanbul",
    "N": 11,
    "N-1": 9,
  },
  {
    "key": "Bangkok",
    "N": 14,
    "N-1": 12,
  },
  {
    "key": "Los Angeles",
    "N": 13,
    "N-1": 11,
  },
  {
    "key": "Madrid",
    "N": 15,
    "N-1": 13,
  },
  {
    "key": "Hong Kong",
    "N": 12,
    "N-1": 10,
  },
  {
    "key": "São Paulo",
    "N": 15,
    "N-1": 13,
  },
  {
    "key": "Mexico City",
    "N": 13,
    "N-1": 11,
  },
  {
    "key": "Seoul",
    "N": 16,
    "N-1": 14,
  }
];

